import * as React from "react";
import {App} from "./App";

declare let jQuery:any;
declare let require:any;
let ReactDOM:any=require('react-dom');

export const PageBuilderContext:any=React.createContext(null);
import 'shared/styles/bootstrap.scss'


export class Bootstrap extends React.Component {
    constructor(prop:any,context:any){
        super(prop,context);

    }

    render(){
        return (
                <App/>

        )
    }

}



window.addEventListener('load',()=>{
    ReactDOM.render(<Bootstrap/>,document.getElementById('AppRot'));
});

